var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBopsLogoExpanded = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "384.82309pt",
    height: "482.564pt",
    viewBox: "0 0 384.82308 482.56399",
    preserveAspectRatio: "xMidYMid",
    id: "svg16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs20"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1,0,0,-0.1,-210.04101,1309.6436)",
    fill: "#7c6cf6",
    stroke: "none",
    id: "g4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3854,13089 c -427,-38 -841,-226 -1153,-524 -771,-735 -804,-1938 -74,-2716 243,-258 560,-447 904,-538 168,-44 311,-62 494,-62 532,0 1019,207 1385,587 274,285 444,621 515,1019 23,125 31,386 16,515 -77,678 -483,1249 -1094,1540 -311,148 -653,209 -993,179 z m 981,-1100 c 76,-28 156,-108 184,-184 32,-86 29,-193 -8,-270 -32,-69 -100,-137 -169,-168 -47,-22 -49,-22 -913,-25 -866,-2 -866,-2 -892,19 l -27,20 v 295 c 0,281 1,295 20,314 20,20 33,20 885,20 854,0 865,0 920,-21 z m 10,-1017 c 69,-31 138,-103 170,-174 24,-53 27,-70 23,-146 -2,-67 -9,-98 -28,-137 -30,-61 -94,-125 -157,-156 l -48,-24 -877,-3 c -869,-2 -878,-2 -898,18 -19,19 -20,32 -20,312 0,287 0,292 22,315 l 22,23 870,-2 871,-3 z",
    id: "path2"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBopsLogoExpanded);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bops_logo_expanded.3b96d3f73ab93062cb9e0d1efdcb5a58.svg";